import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=bbd51de6&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=bbd51de6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../salespro-dev/salespro-dev/sources/client/salespro-dev-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd51de6",
  null
  
)

export default component.exports